import { VAS_SERVICE_API } from '@/const';
import { request } from 'ice';

async function getTableList(data) {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/detail`, { params: data });
}

// 获取综合信息数据
async function getGeneralTableData(data) {
  const res = await request.post('', data);

  return {
    total: res.totalElements,
    list: res.list,
  };
}

// 附件上传
async function attachmentUpload(data) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/uploadValueAddedTaskAttach`, data);
}

// 提交
async function submitData(data: object) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/complete`, data);
}

// 操作日志数据
async function getLogData(data: object) {
  return await request.get(`${VAS_SERVICE_API}/valueAddedTask/showLog`, { params: data });
}

// 关联单号
async function addOrUpdateRelativeNo(data: object) {
  return await request.post(`${VAS_SERVICE_API}/valueAddedTask/addOrUpdateRelativeNo`, data);
}

export { getTableList, getGeneralTableData, attachmentUpload, submitData, getLogData, addOrUpdateRelativeNo };
